import { multiConverter } from './timeConvertot';
import moment from 'moment';
import { renderClientName } from './placeholderConvertors';
import { goalDataTypeEnums } from '../enumValues';
import { timeTypeEnums } from '../../fragments/client/clientSingle/clientClinical/goals/targets/constants';

export { getFreshFileUrl } from './getFreshFileUrl';
export { previewFile } from './previewFile';
export { PermissionsList } from './permissionsList';
export { paginate, SavePage, SendPageSave, SaveParams } from './paginate';
export { gridFilterTab, restoredGridState, persistGridFilters, cancelPendingGridFilterSaves } from './savedFilters';
export { filterByFirstName } from './filterFunctions';
export { activeInactive } from './activeInactive';
export { initAxiosInterceptors } from './axios';
export { ToastSuccess } from './toastSuccess';
export { ToastFail } from './toastFail';
export { FindSuccess, FindSuccessItem } from './findSuccess';
export { FindLoad, FindLoadItem } from './findLoad';
export { ActiveInactiveStatus } from './activeInactiveStatus';
export { ActiveInactiveStatusReverse } from './activeInactiveStatusReverse';
export { FindError, FindErrorItem } from './findError';
export { getPhoneErrorText } from './getPhoneErrorText';
export { isNotEmpty } from './isNotEmpty';
export { makeEnum } from './makeEnum';
export { transformPermission } from './transformPermissions';
export { getValTillTenDig } from './getValTillTenDig';
export { getLimitedVal } from './getLimitedVal';
export { manageStatus, manageType, manageStatusCircle } from './manageStatus';
export { getMenuTitle } from './getMenuTitle';
export { makeCapitalize, textResizer } from './makeCapitalize';
export { useWidth } from './useWidth';
export { hooksForTable } from './hooksForTable';
// export { ImgUploader } from './uploadImages';
export { hooksForErrors } from './hooksForErrors';
export { addHiddenClass } from './addHiddenClass';
export { ssnActions } from './ssnActions';
export { createCodeFromName } from './createCodeFromName';
export { getSkipCount } from './getSkipCount';
export { useWeekInterval } from './useWeekInterval';
export { handleTooltip } from './handleTooltip';
export { getDisplayDependsOnWidth } from './getDisplayDependsOnWidth';
export { PascalCase } from './pascaleCase';
export { RolePermission, PermissionList } from './rolePermissions';
export { multiConverter } from './timeConvertot';
export { ScrollToTop } from './scrollToTop';
export { DownloadFile } from './downloadFile';
export { filterFromTable } from './filterFromTable';
export { InactivityHandler } from './inactivityHandler';
export { useScrollTop } from './useScrollTop';
export { renderClientName, renderStaffName } from './placeholderConvertors';
export { IsImageLoaded } from './isImageLoaded';
export { renderFirstLetters } from './renderFirstLetters';
export { SessionSocket } from './sessionSocket';
export { useSessionSocket } from './useSessionSocket';
export { loadGoogleMaps } from './loadGoogleMaps';
export { formatAddress, addressPlace, isUSAddress } from './formatAddress';

export const convertHours = (unformattedHours) => {
    const minutes = unformattedHours * 60;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = Math.round(minutes % 60);
    return `${hours.toString().padStart(2, '0')}h ${remainingMinutes.toString().padStart(2, '0')}m`;
};

// Delimiter used to encode `${cptCode}<delimiter>${serviceTypeId}` in the CPT service filter option ids.
export const CPT_SERVICE_DELIMITER = '__';

/**
 * Build a CPT service filter option id. Encodes both cptCode and serviceTypeId so the backend can
 * pair them (Service → AuthorizedService join). Falls back to the bare cptCode when no serviceTypeId.
 */
export const makeCptServiceOptionId = (cptCode, serviceTypeId) =>
    serviceTypeId ? `${cptCode}${CPT_SERVICE_DELIMITER}${serviceTypeId}` : cptCode;

/**
 * "570 - FBA": the service code with its service-type label. Services can share a code (Oregon APD
 * bills FBA and PBSP as 570), so the code alone doesn't identify the line. Just the code without a label.
 */
export const formatServiceCodeLabel = (code, label) => [code, label].filter(Boolean).join(' - ');

/**
 * Split CPT service filter selections (composite `cptCode__serviceTypeId` ids, or objects carrying
 * such an `id`) into the two independent `$in` arrays the backend expects: distinct cptCodes and
 * distinct serviceTypeIds.
 */
export const splitCptServiceFilter = (selected = []) => {
    const cptCode = [];
    const serviceTypeId = [];
    (selected || []).forEach((item) => {
        const value = item?.id ?? item;
        const [code, typeId] = String(value).split(CPT_SERVICE_DELIMITER);
        if (code && !cptCode.includes(code)) cptCode.push(code);
        if (typeId && !serviceTypeId.includes(typeId)) serviceTypeId.push(typeId);
    });
    return { cptCode, serviceTypeId };
};

/**
 * Human label for one CPT service filter selection, for an active-filter chip.
 *
 * The option id is composite, so the name has to come from the same `fundingUniqueServices` list the
 * column built its options from. That list loads asynchronously; until it arrives, decode the bare
 * CPT code out of the id rather than rendering a chip the user cannot read.
 */
export const cptServiceLabel = (globalServices, value) => {
    const match = globalServices?.find((i) => makeCptServiceOptionId(i?.cptCode, i?.serviceTypeId) === value);
    if (match) return `${match?.serviceTypeName} (${match?.cptCode})`;
    return String(value).split(CPT_SERVICE_DELIMITER)[0];
};

export const convertToDateTime = (selectedTime) => {
    // Create a Moment.js object using the selected time
    const timeMoment = moment(selectedTime, 'HH:mm');
    // Set the timezone to UTC (Z)
    timeMoment.to('UTC');
    // Format the datetime string
    return timeMoment.format('YYYY-MM-DDTHH:mm:ssZ');
};

function tConvert(time) {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        // time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join('');
}

// Returns '--' for missing input so IN_PROGRESS / unfinished trials don't
// render "undefined:undefined AM" in history logs and edit dialogs. The
// underlying tConvert regex can't match an undefined slice and would
// otherwise concatenate undefined slots into the output template.
export const formatAMPM = (originalTime) => {
    if (!originalTime) return '--';
    let hours = originalTime?.slice(11, 13);
    let minutes = originalTime?.slice(14, 16);
    if (!hours || !minutes) return '--';
    let timeType = hours >= 12 ? 'PM' : 'AM';
    const convertedTime = tConvert(`${hours}:${minutes}`);
    return `${convertedTime} ${timeType}`;
};

export const formatAMPMWidthSecond = (originalTime) => {
    if (!originalTime) return '--';
    let hours = originalTime?.slice(11, 13);
    let minutes = originalTime?.slice(14, 16);
    let seconds = originalTime?.slice(17, 19);
    if (!hours || !minutes || !seconds) return '--';
    let timeType = hours >= 12 ? 'PM' : 'AM';
    const convertedTime = tConvert(`${hours}:${minutes}:${seconds}`);
    return `${convertedTime} ${timeType}`;
};

export const formatAMPMNeW = (originalTime) => {
    if (!originalTime) return '--';
    let hours = originalTime?.slice(11, 13);
    let minutes = originalTime?.slice(14, 16);
    if (!hours || !minutes) return '--';
    let timeType = hours >= 12 ? 'p' : 'a';
    const hours12 = hours % 12 || 12;
    const convertedTime = tConvert(`${hours12}:${minutes}`);
    return `${convertedTime}${timeType}`;
};

export function formatMiles(number) {
    const num = Number(number);
    return num ? num.toLocaleString('en-US') : '--';
}

export function formatDuration(duration) {
    const [hours, minutes] = duration.split('h');
    const trimmedMinutes = Math.abs(parseInt(minutes.trim(), 10)) || 0;
    return `${hours}h ${trimmedMinutes}m`;
}

export const TimeIsGreat = (startTime, endTime) => {
    if (startTime && endTime) {
        const start = new Date();
        const end = new Date();

        const [startHour, startMinute] = startTime.split(':');
        start.setHours(parseInt(startHour));
        start.setMinutes(parseInt(startMinute));

        // Set the hours and minutes for end time
        const [endHour, endMinute] = endTime.split(':');
        end.setHours(parseInt(endHour));
        end.setMinutes(parseInt(endMinute));

        if (end > start) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

export const renderSize = (item) => {
    const bytes = item?.size;
    const KB = 1024;
    const MB = KB * 1024;

    if (bytes >= MB) {
        return (bytes / MB).toFixed(2) + ' MB';
    } else if (bytes >= KB) {
        return (bytes / KB).toFixed(2) + ' KB';
    } else {
        return bytes + ' bytes';
    }
};

export const getFileType = (fileName) => {
    const parts = fileName?.split('.');
    return parts?.length > 1 ? parts[parts?.length - 1] : null;
};

export const base64ToFile = (base64String, fileName) => {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)[1]; // Extract the MIME type (e.g., image/png)
    const bstr = atob(arr[1]); // Decode base64 to binary string
    let n = bstr.length;
    const u8arr = new Uint8Array(n); // Create a Uint8Array to hold binary data

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    const file = new File([u8arr], fileName, { type: mime });
    return file;
};

export const newDateWithoutUtc = (date) => {
    // const newDate = new Date(date);
    // const momentDate = moment(date);
    //
    // const year = momentDate.year();
    // const month = momentDate.month();
    // const day = momentDate.date();
    // newDate.setFullYear(year);
    // newDate.setMonth(month);
    // newDate.setDate(day);
    // newDate.setHours(0, 0, 0, 0);
    //
    // return newDate;

    return moment.utc(date).startOf('day').toDate();
};

export const getNestedError = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

export const renderDate = (date, format) => {
    return moment.utc(date).format(format ? format : 'MM/DD/YYYY');
};

/**
 * "MM/DD/YYYY - MM/DD/YYYY" for a date-range filter, collapsing to the single bound that
 * is set when the range is open-ended. Returns '' when neither bound is set.
 * Local time, not UTC — these are filter bounds the user picked in their own timezone,
 * unlike `renderDate` above which formats stored timestamps.
 */
export const renderDateRange = (from, to) => {
    const start = from ? moment(from).format('MM/DD/YYYY') : '';
    const end = to ? moment(to).format('MM/DD/YYYY') : '';
    if (start && end) return `${start} - ${end}`;
    return start || end;
};

export const checkIfDateIsExpired = (service) => {
    const today = moment.utc(); // Get today's date
    const optionStartDay = moment(service.startDate); // Parse with format
    const optionEndDay = moment(service.endDate).endOf('day'); // Parse with format

    if (today.isAfter(optionEndDay)) {
        return {
            background: 'rgb(254, 243, 242)',
            color: 'rgb(180, 35, 24)',
        };
    }
    if (today.isBetween(optionStartDay, optionEndDay, null, '[]')) {
        return {
            background: 'rgb(236, 253, 243)',
            color: 'rgb(2, 122, 72)',
        };
    }
    if (today.isBefore(optionStartDay)) {
        return {
            background: '#FFFAEB',
            color: '#BF602A',
        };
    }
    return {
        background: 'rgb(254, 243, 242)',
        color: 'rgb(180, 35, 24)',
    };
};

export const toCamelCase = (text) => {
    if (!text) return '--';

    return text
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/(\w)(\w*)/g, (match, g1, g2) => g1.toUpperCase() + g2.toLowerCase())
        .trim();
};

// export const toCamelCase = (text) => {
//     if (text) {
//         return (
//             text?.replace(/(\w)(\w*)/g, function(g0, g1, g2) {
//                 return g1.toUpperCase() + g2.toLowerCase();
//             })
//         );
//     }
// };

export function formatHours(hours) {
    let h = Math.floor(hours).toString().padStart(2, '0');
    let m = Math.round((hours - Math.floor(hours)) * 60)
        .toString()
        .padStart(2, '0');
    return `${h}h ${m}m`;
}

export const sortAlphabetically = (array, key) => {
    return [...array].sort((a, b) => {
        const nameA = (a[key] || '').toString().toLowerCase();
        const nameB = (b[key] || '').toString().toLowerCase();
        return nameA.localeCompare(nameB);
    });
};

export const saveLocalParams = (name, params) => {
    sessionStorage.setItem(name, JSON.stringify(params));
};

export const formatType = (type) => {
    return type
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

/**
 * Client-side twin of the backend's sort, for the tables that hold their whole list in memory.
 *
 * `info` is the same `{ sortType, orderType }` a column header writes, so the three-state header
 * (A→Z, Z→A, off) works here too: with no `sortType` the list falls back to the caller's `key`,
 * which is that table's default order — the counterpart of the order an endpoint returns when it is
 * sent no sort at all. A caller that leaves `info` out gets that default and nothing else, so its
 * headers do nothing; every `AccordionFullTable` that wires `getParams`/`savedParams` must pass the
 * state back in here.
 */
export function sortListByKey(list, key, info) {
    const isValidList = list || [];
    const sortKey = info?.sortType || key;
    // The direction belongs to a column the user picked. Without `sortType` the list is in its
    // default order, and a leftover `orderType` must not quietly reverse it.
    const isDescending = !!info?.sortType && info?.orderType === 'DESC';

    const getValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc?.[part], obj) ?? '';
    };

    // Case-insensitive, numeric-aware compare — mirrors Mongo `.collation({ locale: 'en', strength: 2 })`
    // and native numeric ordering (so "2" sorts before "10", not lexicographically).
    const compare = (a, b) => a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true });

    return [...isValidList].sort((a, b) => {
        let valueA, valueB;

        if (sortKey === 'fullName') {
            valueA = `${a.firstName || ''} ${a.lastName || ''}`.trim();
            valueB = `${b.firstName || ''} ${b.lastName || ''}`.trim();
        } else {
            valueA = getValue(a, sortKey).toString();
            valueB = getValue(b, sortKey).toString();
        }

        return isDescending ? compare(valueB, valueA) : compare(valueA, valueB);
    });
}

export function convertTo12HourFormat(time24) {
    if (time24) {
        const [hourStr, minute] = time24.split(':');
        let hour = parseInt(hourStr, 10);
        const period = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12; // Convert 0 -> 12, 13 -> 1, etc.
        const formattedHour = String(hour).padStart(2, '0');
        return `${formattedHour}:${minute}${period}`;
    }
}

export function formatNumberToFix(num) {
    const fixed3 = num.toFixed(3); // always 3 decimals
    if (fixed3[fixed3.length - 1] === '0') {
        // if 3rd decimal is 0 → show 2 decimals
        return num.toFixed(2);
    }
    return fixed3; // otherwise keep 3 decimals
}

export function stripHtml(html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

// export function formatSecondDuration(seconds, convertByText) {
//     const h = Math.floor(seconds / 3600);
//     const m = Math.floor((seconds % 3600) / 60);
//     const s = seconds % 60;
//
//     if(convertByText){
//         return `${h}h ${m.toString().padStart(2, '0')}m ${s.toString().padStart(2, '0')}s`;
//     }else {
//         return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
//     }
// }
export function formatSecondDuration(seconds, convertByText) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);

    // Keep up to 2 decimals but remove trailing zeros
    let s = (seconds % 60).toFixed(2).replace(/\.?0+$/, '');

    if (convertByText) {
        return `${h}h ${m.toString().padStart(2, '0')}m ${s}s`;
    } else {
        return `${h}:${m.toString().padStart(2, '0')}:${s}`;
    }
}

export function formatSeconds(seconds) {
    if (!seconds || seconds < 0) return '0s';

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);

    const result = [];
    if (h) result.push(`${h}h`);
    if (m) result.push(`${m}m`);
    if (s) result.push(`${s}s`);

    return result.join(' ') || '0s';
}
export function getMonthsBetweenDates(startDateStr, endDateStr) {
    const start = moment(startDateStr, 'YYYY-MM-DD');
    const end = moment(endDateStr, 'YYYY-MM-DD');
    const months = [];
    let isFirst = true;

    while (start.isSameOrBefore(end, 'month')) {
        if (isFirst) {
            months.push(start.format('YYYY-MM-DD'));
            isFirst = false;
        } else {
            months.push(start.startOf('month').format('YYYY-MM-DD'));
        }
        start.add(1, 'month');
    }
    return months;
}

export const convertSecondToMinute = (type, second) => {
    if (type === 'MINUTE') {
        return second * 60;
    }
    return +second;
};

export const renderGoalValueType = (goalById) => {
    const optionTimeType = goalById?.dataType === goalDataTypeEnums.LATENCY ? goalById?.options[0] : null;
    const type = goalById?.dataType;

    switch (type) {
        case goalDataTypeEnums.PERCENT:
        case goalDataTypeEnums.PARTIAL_INTERVAL:
        case goalDataTypeEnums.WHOLE_INTERVAL:
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return '%';

        case goalDataTypeEnums.DURATION:
        case goalDataTypeEnums.IRT:
            return 's';

        case goalDataTypeEnums.LATENCY:
            return optionTimeType === timeTypeEnums?.SECUND ? 's' : optionTimeType === timeTypeEnums?.MINUTE ? 'm' : '';

        case goalDataTypeEnums.RATING:
            return '';
        case goalDataTypeEnums.FREQUENCY:
            return '';
        default:
            return '';
    }
};
